/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import template from './email-template-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-email-template-list-page',
  template
})
export class EmailTemplateListPageComponent extends AdminResourceListPageBase implements OnInit {
  readonly itemStateName = 'app.adm.email-templates.email-template';

  showTeams = false;
  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'type'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) private LocalUserPermissions: any
  ) {
    super(LocalNetworkProfile);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.showTeams = !!this.LocalUserPermissions.getAllVisPermissions().MANAGE_SYSTEM;
    if (this.showTeams) {
      this.columns = [...this.columns, {label: 'team', param: '', sortable: false}];
    }
  }
}
